var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 30,
    height: 30,
    viewBox: "0 0 172 172",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3498db"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,86c0,47.41968 38.58032,86 86,86c47.41968,0 86,-38.58032 86,-86c0,-47.41968 -38.58032,-86 -86,-86c-47.41968,0 -86,38.58032 -86,86zM88.53353,36.88314l32.25,32.25c0.68587,0.68587 1.0498,1.6027 1.0498,2.53353c0,0.46191 -0.08748,0.92733 -0.27295,1.37175c-0.5529,1.34025 -1.86165,2.21159 -3.31038,2.21159h-7.16667c-0.95182,0 -1.86165,-0.37793 -2.53353,-1.0498l-15.38314,-15.38314v73.76628c0,1.98063 -1.6027,3.58333 -3.58333,3.58333h-7.16667c-1.98063,0 -3.58333,-1.6027 -3.58333,-3.58333v-73.76628l-15.38314,15.38314c-0.67187,0.67187 -1.58171,1.0498 -2.53353,1.0498h-7.16667c-1.44873,0 -2.75749,-0.87134 -3.31038,-2.21159c-0.5599,-1.34375 -0.24845,-2.87996 0.77686,-3.90527l32.25,-32.25c1.39974,-1.39974 3.66732,-1.39974 5.06706,0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToUp);
export default __webpack_public_path__ + "static/media/to-up.b87dda8de716368bd1c912c3cf62df42.svg";
export { ForwardRef as ReactComponent };